<div id="chart" #chart>
    <div *ngIf="loading">Cargando ...</div>
</div>